import * as React from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

const SvgSendGearIcon = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path
      d="M3 19.383v-6.024l8.275-2.168L3 9.024V3l14.856 6.263a4 4 0 0 0-.288-.048 3 3 0 0 0-.389-.024q-2.925 0-4.962 2.057-2.037 2.055-2.037 4.981v.057q0 .027.011.057z"
      fill="currentColor"
    />,
    <path
      d="m17.428 11.191.275 1.352q.244.1.466.217.221.115.448.276l1.303-.402.952 1.612-1.043.9q.045.243.045.542t-.045.543l1.043.9-.952 1.618-1.303-.408a4.3 4.3 0 0 1-.914.499l-.275 1.351h-1.9l-.27-1.351a4.372 4.372 0 0 1-.913-.499l-1.308.408-.947-1.618 1.037-.9a3 3 0 0 1-.044-.543q0-.299.044-.543l-1.037-.899.947-1.612 1.308.402q.226-.16.448-.276a5 5 0 0 1 .465-.217l.27-1.352zm-.92 2.65a1.768 1.768 0 1 0 0 3.536 1.768 1.768 0 0 0 0-3.535"
      fill="currentColor"
    />,
  )
export default SvgSendGearIcon
